import {
  IsEmail,
  IsInt,
  IsNumber,
  IsOptional,
  IsString
} from 'class-validator';

/**
 * Request DTO used when creating delivery job for Ondway.
 */
export class CreateDeliveryJobForOndwayRequestDto {
  /** Fetch service_id from GetServices API */
  @IsNumber()
  service_id: number;

  /** Customer Email (Sender Email) */
  @IsEmail()
  email: string;

  /** 1 – Normal, 2 – Same Day */
  @IsInt()
  priority_id: number;

  /** Google auto completed pickup address */
  @IsString()
  pickup_address: string;

  /** Pickup customer name */
  @IsString()
  pickup_name: string;

  /** Pickup phone number */
  @IsString()
  pickup_phone: string;

  /** Google auto completed drop off address */
  @IsString()
  drop_address: string;

  /** Latitude of drop off address */
  @IsString()
  @IsOptional()
  drop_latitude: string | null;

  /** Longitude of drop off address */
  @IsString()
  @IsOptional()
  drop_longitude: string | null;

  /** Drop off customer name */
  @IsString()
  drop_name: string;

  /** Drop off phone number */
  @IsString()
  drop_phone: string;

  /** Drop off phone number code */
  @IsString()
  drop_phone_code: string;

  /** Drop off notes */
  @IsOptional()
  @IsString()
  drop_note: string;

  constructor(params: {
    serviceId: number;
    email: string;
    priorityId: number;
    pickupAddress: string;
    pickupName: string;
    pickupPhone: string;
    dropAddress: string;
    dropLatitude: string | null;
    dropLongitude: string | null;
    dropName: string;
    dropPhoneCode: string;
    dropPhone: string;
    dropNote: string;
  }) {
    this.service_id = params.serviceId;
    this.email = params.email;
    this.priority_id = params.priorityId;
    this.pickup_address = params.pickupAddress;
    this.pickup_name = params.pickupName;
    this.pickup_phone = params.pickupPhone;
    this.drop_address = params.dropAddress;
    if (params.dropLatitude) {
      this.drop_latitude = params.dropLatitude;
    }
    if (params.dropLongitude) {
      this.drop_longitude = params.dropLongitude;
    }
    this.drop_name = params.dropName;
    this.drop_phone = params.dropPhone;
    this.drop_phone_code = params.dropPhoneCode;
    this.drop_note = params.dropNote;
  }
}
